<template>
    <div class="block">
        <a href="#" class="title" @click.prevent="getItems">Ответственный за реализацию проекта</a>
        <transition name="fade">
        <div class="content" v-if="isLoad">
            <table>
                <thead>
                <tr>
                    <th>ФИО (полностью)</th>
                    <th>Должность</th>
                    <th>Телефон</th>
                    <th>Еmail</th>
                </tr>
                </thead>
                <tbody v-if="items">
                    <tr v-bind:key="item.id" v-for="item in items">
                        <td>{{ item.fio }}</td>
                        <td>{{ item.post }}</td>
                        <td>{{ item.phone }}</td>
                        <td>{{ item.email }}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="4">Загрузка данных...</td>
                    </tr>
                </tbody>
            </table>
        </div>
        </transition>
    </div>
</template>

<script>
    import Axios from 'axios'
    import _ from 'lodash'

    export default {
        name: "Responsible",

        data(){
            return {
                isLoad:false,
                items: false,
            }
        },


        created(){
        },


        methods:{
            getItems(){
                if(!this.isLoad && !this.items) {
                    this.isLoad = true
                    const $this = this
                    const path = this.$store.state.api + this.$store.state.apiResponsibles + "?eoId=" + this.$store.state.eoId;
                    Axios({
                        method: "get",
                        url: path
                    }).then((res) => {
                        if (res.status == 200 && res.data.result == 'success') {
                            $this.items = _.filter(res.data.data, function (o) {
                                return (
                                    (typeof(o.projectType.altName) !== 'undefined')
                                    && (o.projectType.altName == $this.$store.state.type)
                                )
                            });
                        }
                    })
                }else{
                    this.isLoad = !this.isLoad
                }
            }
        },
    }
</script>

<style scoped>

</style>
